// GET /payments/card-surcharge?amount=<decimal> (#297 / DecisionLog §1.11). CONFIRMED
// against API main @ 386f687 (PR 242) — Features/Payments/CalculateCardSurcharge.
// Display-only quote for the fee line before Place Order. Server math is
// authoritative: the UI renders both numbers verbatim and NEVER computes
// amount × rate itself. The server binds `amount` as a STRICT invariant-culture
// decimal and answers 400 for garbage/missing/zero/negative — see
// usePaymentQuoteApi for the serialization rules.
export interface SurchargeQuoteResponse {
    // The fee in dollars for the exact amount quoted.
    surchargeAmount: number;
    // FRACTION, not percent: 0.029 means 2.9%. Display convention: always render
    // through formatSurchargeRate below — never string-build a percentage elsewhere,
    // so the rendered rate can't drift from this convention.
    rate: number;
}

// Intl does the fraction→percent conversion and trims trailing zeros (0.029 → "2.9%",
// 0.03 → "3%") — a hand-rolled rate * 100 would print float artifacts like
// "2.8999999999999998%".
const surchargeRateFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 2,
});

export const formatSurchargeRate = (rate: number): string =>
    surchargeRateFormatter.format(rate);
